import { render } from "./IUPTLView.vue?vue&type=template&id=1404bf47&scoped=true&ts=true"
import script from "./IUPTLView.vue?vue&type=script&lang=ts"
export * from "./IUPTLView.vue?vue&type=script&lang=ts"

import "./IUPTLView.vue?vue&type=style&index=0&id=1404bf47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1404bf47"]])

export default __exports__